import useMobile from "customHooks/useMobile";
import CustomContentLoader from "../ReuseableCompos/CustomContentLoader";

const DonationAccordionSkeleton = () => {
  const isMobile = useMobile("md");
  const numbers = isMobile
    ? {
        vb: "0 0 50 12",
        rx: "4",
        ry: "4",
        height: "8",
      }
    : {
        vb: "0 0 50 10",
        rx: "2",
        ry: "2",
        height: "4",
      };

  return (
    <div className={`w-100 px-3 px-md-0 m-md-0 gx-0 gx-md-0 ${"border-top"}`}>
      <div className="col-md-12 mx-auto">
        <div className=" py-4  flex-grow-1 cursor d-flex flex-wrap align-items-center justify-content-between p-0 text-capitalize row">
          <div className="col-md-2 col-4">
            <CustomContentLoader viewBox={numbers.vb}>
              <rect
                x="0"
                y="4"
                rx={numbers.rx}
                ry={numbers.ry}
                width="45"
                height={numbers.height}
              />
            </CustomContentLoader>
          </div>
          <div className="col-md-2 col-4">
            {" "}
            <CustomContentLoader viewBox={numbers.vb}>
              <rect
                x="0"
                y="4"
                rx={numbers.rx}
                ry={numbers.ry}
                width="50"
                height={numbers.height}
              />
            </CustomContentLoader>
          </div>
          <div className="col-md-2 col-4">
            <CustomContentLoader viewBox={numbers.vb}>
              <rect
                x="0"
                y="4"
                rx={numbers.rx}
                ry={numbers.ry}
                width="30"
                height={numbers.height}
              />
            </CustomContentLoader>
          </div>
          <div className="col-md-2 col-4">
            <CustomContentLoader viewBox={numbers.vb}>
              <rect
                x="0"
                y="4"
                rx={numbers.rx}
                ry={numbers.ry}
                width="40"
                height={numbers.height}
              />
            </CustomContentLoader>
          </div>
          <div className="col-md-2 col-4">
            {" "}
            <CustomContentLoader viewBox={numbers.vb}>
              <rect
                x="0"
                y="4"
                rx={numbers.rx}
                ry={numbers.ry}
                width="50"
                height={numbers.height}
              />
            </CustomContentLoader>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationAccordionSkeleton;
